import Grid from "@material-ui/core/Grid";
import Link from "@material-ui/core/Link";
import { createBrowserHistory } from "history";
import React, { Component } from "react";
import { userFarmDetail } from "../../../config/farmDetails";
import { harvestYearDetail } from "../../../config/harvestYearDetail";
import Button from "../../FormElement/Button";
import { validForm } from "../../FormElement/FormValidator";
import InputFiled from "../../FormElement/InputFiled";


const history = createBrowserHistory();

class SubFarmForm extends Component {
  constructor(props) {
    super(props);
    const { farmInfo } = props;
    this.state = {
      farmInfo: {
        farmName: farmInfo ? farmInfo.farmName : null,
        streetAddress: farmInfo ? farmInfo.streetAddress : null,
        town: farmInfo ? farmInfo.town : null,
        state: farmInfo ? farmInfo.state : null,
        zipCode: farmInfo ? farmInfo.zipCode : null,
        farmSize: farmInfo ? farmInfo.farmSize : null,
        harvestYear: harvestYearDetail().name
      },
      formErrors: {
        farmName: "",
        streetAddress: "",
        town: "",
        state: "",
        zipCode: "",
        farmSize: ""
      },
      isInvalid: true,
      edited: false
    };
  }

  componentDidUpdate = () => {
    if (this.state.edited) {
      window.onbeforeunload = () => true;
    } else {
      window.onbeforeunload = undefined;
    }
  };

  handleChange = event => {
    if (!this.state.edited) this.setState({ edited: true });
    const { name, value } = event.target;
    if (name === "street_address" || name === "town") {
      if (value.match(/^(.|\n){0,100}$/)) {
        this.updateState(name, value);
      }
    } else if (name === "state" || name === "zipCode") {
      if (value.match(/^(.|\n){0,20}$/)) {
        this.updateState(name, value);
      }
    } else if (name === "farmSize") {
      if (value.match(/^\d{0,10}(\.\d{0,2})?$/)) {
        this.updateState(name, value);
      }
    } else {
      this.updateState(name, value);
    }
  };

  updateState = (name, value) => {
    this.setState(
      prevState => {
        return {
          farmInfo: {
            ...prevState.farmInfo,
            [name]: value
          }
        };
      },
      () => {
        const { farmInfo } = this.state;
        const requiredFields = { ...farmInfo };
        delete requiredFields.farmSize;
        this.validateAll(requiredFields);
      }
    );
  };

  handleError = (name, error) => {
    this.setState(
      prevState => {
        return {
          formErrors: {
            ...prevState.formErrors,
            [name]: error
          }
        };
      },
      () => {
        const { farmInfo } = this.state;
        const requiredFields = { ...farmInfo };
        delete requiredFields.farmSize;
        this.validateAll(requiredFields);
      }
    );
  };

  validateAll = formFields => {
    this.setState({
      isInvalid: validForm(this.state.formErrors, formFields)
    });
  };

  onCancel = e => {
    e.preventDefault();
    history.goBack();
  };

  handleSubmit = e => {
    e.preventDefault();
    this.setState({ isInvalid: true });
    const { farmInfo } = this.state;
    farmInfo.harvestYear = harvestYearDetail().name;
    const formData = { ...farmInfo };
    formData.address = {};
    delete formData.streetAddress;
    delete formData.zipCode;
    delete formData.town;
    delete formData.state;
    formData.address.streetAddress = farmInfo.streetAddress;
    formData.address.town = farmInfo.town;
    formData.address.state = farmInfo.state;
    formData.address.zipCode = farmInfo.zipCode;
    this.props.handleSubmit(formData);
  };

  render() {
    const { farmInfo, isInvalid } = this.state;
    const { editMode = false, formLabel, buttonLabel } = this.props;
    return (
      <div className="">
        <div className="innermainform">
          <p className="loginHeader">{formLabel}</p>
          <Grid container spacing={16}>
            <Grid item xs={12}>
              <InputFiled
                value={userFarmDetail().name || this.props.MainFarmName}
                label="Main Farm"
                type="text"
                // validations={['onlyAlpha', 'required']}
                name="contractNumber"
                // handleError={this.handleError}
                handleChange={this.handleChange}
                disabled
              />
            </Grid>
            <Grid item xs={12}>
              <InputFiled
                value={farmInfo.farmName}
                label="Name of the Farm"
                type="text"
                required
                name="farmName"
                validations={["required"]}
                handleChange={this.handleChange}
                //handleError={this.handleError}
              />
            </Grid>
            <Grid item xs={12}>
              <InputFiled
                label="Street Address"
                value={farmInfo.streetAddress}
                required
                handleChange={this.handleChange}
                validations={["required"]}
                //handleError={this.handleError}
                multiline
                rows={2}
                rowsMax={4}
                type="text"
                name="streetAddress"
              />
              <InputFiled
                label="Town/City"
                value={farmInfo.town}
                required
                handleChange={this.handleChange}
                validations={["required"]}
                //handleError={this.handleError}
                type="text"
                name="town"
              />
              <InputFiled
                label="State"
                value={farmInfo.state}
                required
                handleChange={this.handleChange}
                validations={["required"]}
                //handleError={this.handleError}
                type="text"
                name="state"
              />
              <InputFiled
                label="Zip Code"
                value={farmInfo.zipCode}
                required
                handleChange={this.handleChange}
                validations={["required"]}
                //handleError={this.handleError}
                type="text"
                name="zipCode"
              />
            </Grid>
            <Grid item xs={12}>
              <InputFiled
                value={farmInfo.farmSize}
                label="Size of the Farm (in Acres)"
                type="text"
                name="farmSize"
                validations={["onlyNumber"]}
                handleChange={this.handleChange}
                //handleError={this.handleError}
              />
            </Grid>
          </Grid>
          <div className="signInSection" style={signInSectionStyle}>
            <Link
              className="cancelButton"
              component="button"
              onClick={this.onCancel}
            >
              Cancel
            </Link>
            <Button
              name={buttonLabel}
              disabled={isInvalid}
              onclick={this.handleSubmit}
              styleClass="signIn"
            />
          </div>
        </div>
      </div>
    );
  }
}

export default SubFarmForm;

const signInSectionStyle = {
  display: "flex",
  alignItems: "baseline",
  justifyContent: "space-between"
};



// WEBPACK FOOTER //
// ./src/components/private/FarmManagment/SubFarmForm.js